import { TMeetingInfo } from "../../../../../../services/api/instances/meetingsApi/types";
import { useAppSelector } from "../../../../../../services/redux/hooks/use-selector";
import { exportTranscriptToDocx } from "../../../../helpers/exportTranscriptToDocx";
import { getActiveSpeaker } from "../../../../helpers/getActiveSpeaker";
import { useTranscriptionEditor } from "../../../../hooks/use-transcription-editor";
import {
  selectSpeakers,
  selectTranscriptionInfo,
  selectUniqueSpeakers,
} from "../../../../redux/selectors";
import { SpeechEditor } from "./SpeechEditor";
import { TranscriptHeader } from "./TranscriptHeader";
import styles from "./styles.module.css";

export const TranscriptEditor = () => {
  const { onSelectSpeaker, handleChangeSpeech, handleTranscriptActions } =
    useTranscriptionEditor();
  const speakers = useAppSelector(selectSpeakers);
  const uniqSpeakers = useAppSelector(selectUniqueSpeakers);
  const info = useAppSelector(selectTranscriptionInfo);

  return (
    <div className={styles["result-block"]}>
      <TranscriptHeader
        handleExportFile={() =>
          exportTranscriptToDocx(info as TMeetingInfo, speakers)
        }
        isDisabled={speakers.length === 0}
      />
      <div className={styles["speech-container"]}>
        {getActiveSpeaker(speakers)?.map((speaker) => {
          if (speaker.speech_content !== null) {
            return (
              <SpeechEditor
                key={speaker.id}
                speakers={uniqSpeakers}
                speaker={speaker}
                handleActions={handleTranscriptActions}
                onSelectSpeaker={onSelectSpeaker}
                onSpeechChange={handleChangeSpeech}
              />
            );
          }
        })}
      </div>
    </div>
  );
};
